import { ref } from 'vue';
import VersionService from './service';

const versionVue = '37.35 Jaygarcia Saturn';

const props = ref({
  apiVersion: {
    version: {
      type: String,
      default: '',
    },
    nickName: {
      type: String,
      default: '',
    },
    etradeVersion: {
      type: String,
      default: '37.35',
    },
  },
});

async function loadVersion() {
  await VersionService.getAbout().then((data) => {
    props.value.apiVersion = data;
  });
}

export { props, versionVue, loadVersion };
